import { render, staticRenderFns } from "./productEditChecklist.vue?vue&type=template&id=53e70781&scoped=true"
import script from "./productEditChecklist.vue?vue&type=script&lang=js"
export * from "./productEditChecklist.vue?vue&type=script&lang=js"
import style0 from "./productEditChecklist.vue?vue&type=style&index=0&id=53e70781&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e70781",
  null
  
)

export default component.exports